// extracted by mini-css-extract-plugin
module.exports = {"descriptions":"_23IPj-GIdbyF5UnCxAmmKT","tags":"_2TePisSgrOigee649e4atK","tag":"_2_L5pmxxDmrK7aFAK6cI16"};